import { React, useState, useEffect } from "react";
import Header from "../components/HeaderMui";
import useIsMobile from "../hooks/useIsMobile";
import useHeaderShrink from "../hooks/useHeaderShrink";
import useSwipeGesture from "../hooks/useSwipeGesture";
import { useNavigate, useLocation } from "react-router-dom";
import { useCart } from "../context/CartContext";
import ContactUs from "../components/ContactUs";
import PopUp from "../components/popUp";
import TextField from "@mui/material/TextField";
import {
  Grid,
  Paper,
  Typography,
  Button,
  Box,
  Stack,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { isVirtualServiceBundle } from "../utils/bundleUtils";
import useFetchMeals from "../hooks/useFetchMeals";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useTranslation } from "react-i18next";
import useFetchBundles from "../hooks/useFetchBundles";
import MealPopUp from "../components/mealPopUp";
import DiscountProgressBar from "../components/DiscountProgressBar";
import CustomMealPopUp from "../components/customMealPopUp";
import useFetchProducts from "../hooks/useFetchProducts";
import "./Order.css";
import "./Home.css";

function Order() {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const toggleMobileMenu = () => setShowMobileMenu((prev) => !prev);
  const isMobile = useIsMobile();
  const { headerHeight, isScrolled } = useHeaderShrink(isMobile);
  const { cart, addToCart, removeFromCart, updateQty } = useCart();
  const [addToCartFlags, setAddToCartFlags] = useState({});
  const [showCartMenu, setShowCartMenu] = useState(false);
  const toggleCartMenu = () => setShowCartMenu((prev) => !prev);
  const { meals, loading: mealsLoading, error, refetch } = useFetchMeals();
  const {
    bundles,
    loading: bundlesLoading,
    bundleError,
    bundlesRefetch,
  } = useFetchBundles();

  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const scrollToSection = (id) => {
    navigate("/", { state: { scrollToId: id } });
  };

  const foundBundles = bundles.length > 0;
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedBundle, setSelectedBundle] = useState(null);
  const [openMealPopup, setOpenMealPopup] = useState(false);
  const [selectedMeal, setSelectedMeal] = useState(null);
  const [total, setTotal] = useState(0);
  const [openCustomMealPopup, setOpenCustomMealPopup] = useState(false);
  const [virtualBundleOpen, setVirtualBundleOpen] = useState(false);
  const [virtualBundle, setVirtualBundle] = useState(null);

  const enabledCustomMeal = true;
  useEffect(() => {
    if (cart.length >= 0) {
      setTotal(cart.reduce((sum, item) => sum + item.price * item.qty, 0));
    }
  }, [cart]);



  const { products, loading } = useFetchProducts();


  const mealsWithCustom = !loading && products.length > 0
  ? [{
      id: "custom-meal",
      name: t("createCustomMeal"),
      imageUrl: "/customizedMeal.png",
      isCustom: true,
    }]
  : [];

  const handleMealClick = (meal) => {
    setSelectedMeal(meal);
    setOpenMealPopup(true);
  };

  const handleBundleClick = (bundle) => {
    if (isVirtualServiceBundle(bundle)) {
      setVirtualBundle(bundle);
      setVirtualBundleOpen(true);
      return;
    }
    setSelectedBundle(bundle);
    setOpenPopup(true);
  };

  const addVirtualBundleToCart = () => {
    if (!virtualBundle) return;
    const b = virtualBundle;
    addToCart({
      id: `${b.id}-${
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID().slice(0, 8)
          : `${Date.now()}-${Math.floor(Math.random() * 1e6)}`
      }`,
      baseBundleId: b.id,
      name: b.name,
      price: b.price,
      qty: 1,
      meals: [],
      mealsByWeek: [],
      description: b.description,
      imageUrl: b.imageUrl,
      totalMeals: 0,
      weeks: 0,
      excludeDeliveryFee: !!b.excludeDeliveryFee,
      skipMealSelection: true,
    });
    setVirtualBundleOpen(false);
    setVirtualBundle(null);
  };

  useEffect(() => {
    const flags = {};

    meals.forEach((meal) => {
      const found = cart.find((item) => item.id === meal.id);
      flags[meal.id] = !found; // true if not in cart (show addToCart), false if in cart
    });

    setAddToCartFlags(flags);
  }, [cart, meals]);

  // Open meal popup when arriving from home meal cards
  useEffect(() => {
    const mealId = location.state?.mealId;
    if (!mealId || mealsLoading || !meals?.length) return;

    const meal = meals.find(
      (m) => m.id === mealId || String(m.id) === String(mealId)
    );
    if (!meal) return;

    setSelectedMeal(meal);
    setOpenMealPopup(true);
    navigate(location.pathname, { replace: true, state: {} });
  }, [location.state, location.pathname, meals, mealsLoading, navigate]);

  useSwipeGesture({
    onSwipeLeft: () => setShowMobileMenu(true),
    onSwipeRight: () => setShowMobileMenu(false),
    isMenuVisible: showMobileMenu,
  });
  const handleQuantityChange = (meal, newValue) => {
    const quantity = parseInt(newValue, 10);
    if (isNaN(quantity) || quantity < 0) return;

    if (quantity === 0) {
      removeFromCart(meal.id);
    } else {
      updateQty(meal.id, quantity);
    }
  };
  return (
    <div className="Order order-page" dir="rtl">
      {/* Header */}
      <Header
        isScrolled={isScrolled}
        headerHeight={headerHeight}
        showMobileMenu={showMobileMenu}
        toggleMobileMenu={toggleMobileMenu}
        scrollToSection={scrollToSection}
        showCartMenu={showCartMenu}
        toggleCartMenu={toggleCartMenu}
      />

      {mealsLoading || bundlesLoading ? (
        <main
          style={{
            marginTop: isScrolled
              ? headerHeight
              : `calc(${headerHeight} + 2.85rem)`,
            transition: "margin-top 0.3s ease-out",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: `calc(100vh - ${headerHeight})`,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <img
              src="/loadingAnimation1.svg"
              alt="Loading animation"
              style={{ width: "200px", height: "200px", display: "block" }}
            />

            <p>{t("Loading...")}</p>
          </Box>
        </main>
      ) : (
        <main
          style={{
            marginTop: isScrolled
              ? headerHeight
              : `calc(${headerHeight} + 2.85rem)`,
            transition: "margin-top 0.3s ease-out",
          }}
        >
          <Dialog
            open={virtualBundleOpen}
            onClose={() => {
              setVirtualBundleOpen(false);
              setVirtualBundle(null);
            }}
            fullWidth
            maxWidth="xs"
          >
            {virtualBundle && (
              <>
                <DialogTitle
                  sx={{
                    fontFamily: "Tajawal",
                    textAlign: "center",
                    pr: 5,
                  }}
                >
                  <IconButton
                    aria-label="close"
                    onClick={() => {
                      setVirtualBundleOpen(false);
                      setVirtualBundle(null);
                    }}
                    sx={{ position: "absolute", left: 8, top: 8 }}
                  >
                    ×
                  </IconButton>
                  {virtualBundle.name}
                </DialogTitle>
                <DialogContent sx={{ fontFamily: "Tajawal", textAlign: "center" }}>
                  <Typography variant="body1" sx={{ py: 1 }}>
                    {virtualBundle.description}
                  </Typography>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
                  <Button variant="contained" color="success" onClick={addVirtualBundleToCart}>
                    {t("addToCart")}
                  </Button>
                </DialogActions>
              </>
            )}
          </Dialog>
          <PopUp
            open={openPopup}
            handleClose={() => setOpenPopup(false)}
            bundle={selectedBundle}
            addToCart={addToCart}
          />
          <MealPopUp
            open={openMealPopup}
            meal={selectedMeal}
            handleClose={() => setOpenMealPopup(false)}
            cart={cart}
            addToCart={addToCart}
            updateQty={updateQty}
            removeFromCart={removeFromCart}
            handleQuantityChange={handleQuantityChange}
          />
          {openCustomMealPopup && products.length > 0 && (
            <CustomMealPopUp
              open={openCustomMealPopup}
              handleClose={() => setOpenCustomMealPopup(false)}
              cart={cart}
              addToCart={addToCart}
              updateQty={updateQty}
              removeFromCart={removeFromCart}
              handleQuantityChange={handleQuantityChange}
              products={products}
            />
          )}

          {foundBundles && (
            <Typography
              variant="h5"
              align="center"
              mb={4}
              pt={4}
              className="order-page__title"
            >
              {t("bundle")}
            </Typography>
          )}
          <div style={{ justifyContent: "center", display: "flex" }}>
            <Stack
              direction={{ sm: "column", lg: "row" }}
              sx={{
                width: "100%",
                height: { sm: "auto", lg: "50vh" },
                justifyContent: "center",
                gap: 3,
                padding: 2,
                paddingTop: 3,
              }}
            >
              {bundles.map((bundle) => (
                <Box
                  key={bundle.id}
                  position="relative"
                  width={{ sm: "100%", lg: "22%" }}
                >
                  <Paper
                    className="order-bundle-card"
                    sx={{
                      position: "relative",
                      backgroundColor: "#eaf7ef",
                      backgroundImage: `url(${bundle.imageUrl})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: 2,
                      textAlign: "center",
                      marginBottom: { sm: 2, lg: 0 },
                      height: "100%",
                      minHeight: { xs: 220, lg: "100%" },
                      cursor: bundle.count === 0 ? "default" : "pointer",
                    }}
                    onClick={() =>
                      bundle.count !== 0 && handleBundleClick(bundle)
                    }
                  >
                    {/* 🔴 Strap */}
                    {bundle.count === 0 && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          backgroundColor: "#c62828",
                          color: "#fff",
                          padding: "4px 12px",
                          fontSize: "0.75rem",
                          fontWeight: "bold",
                          borderBottomLeftRadius: "8px",
                          zIndex: 10,
                          fontFamily: "Tajawal",
                        }}
                      >
                        {t("unavalible")}
                      </Box>
                    )}

                    {/* 🔳 Grey overlay */}
                    {bundle.count === 0 && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          bgcolor: "rgba(180, 180, 180, 0.6)",
                          zIndex: 1,
                          borderRadius: 1,
                        }}
                      />
                    )}

                    {/* 🧾 Content goes here (Typography, etc.) */}
                    <Box sx={{ position: "relative", zIndex: 2 }}>
                      <Typography
                        variant="h6"
                        mb={1}
                        color="white"
                        sx={{ textShadow: "0 1px 2px rgba(0,0,0,1)" }}
                        fontSize="clamp(2.2rem, 2.8vw, 2.5rem)"
                        fontWeight="bold"
                      >
                        {bundle.name}
                      </Typography>
                      <Typography
                        variant="body2"
                        mb={2}
                        color="white"
                        sx={{ textShadow: "0 1px 2px rgba(0,0,0,1)" }}
                        fontSize="clamp(1.6rem, 2.8vw, 1.8rem)"
                        fontWeight="bold"
                      >
                        {bundle.description}
                      </Typography>
                      <Typography
                        variant="h5"
                        color="white"
                        sx={{ textShadow: "0 1px 2px rgba(0,0,0,1)" }}
                        fontSize="clamp(1.2rem, 3vw, 2rem)"
                        fontWeight="bold"
                      >
                        {bundle.price} ₪
                      </Typography>
                      {!bundle.excludeDeliveryFee && (
                        <Typography
                          variant="body2"
                          component="p"
                          color="#fff"
                          sx={{
                            fontSize: "clamp(0.95rem, 2.8vw, 1.2rem)",
                            fontWeight: 800,
                            fontFamily: "Tajawal",
                            direction: "rtl",
                            lineHeight: 1.45,
                            mt: 1.25,
                            maxWidth: "100%",
                            px: 0.5,
                            letterSpacing: "0.02em",
                            textShadow: [
                              "0 0 2px rgba(0,0,0,1)",
                              "0 0 10px rgba(0,0,0,0.95)",
                              "0 2px 4px rgba(0,0,0,1)",
                              "1px 1px 0 rgba(0,0,0,0.9)",
                              "-1px -1px 0 rgba(0,0,0,0.9)",
                              "0 -1px 0 rgba(0,0,0,0.85)",
                            ].join(", "),
                          }}
                        >
                          {"* "}
                          {t("bundleExcludesDelivery")}
                        </Typography>
                      )}
                    </Box>
                  </Paper>
                </Box>
              ))}
            </Stack>
          </div>
          <Box sx={{ p: 2 }}>
            <Typography
              variant="h5"
              align="center"
              mb={4}
              className="order-page__title"
            >
              {t("meals")}
            </Typography>
            <Box
              sx={{ width: "100%", display: "flex", justifyContent: "center" }}
            >
              <Grid
                container
                rowSpacing={2}
                columnSpacing={1}
                justifyContent="center"
                maxWidth="900px"
              >
                {[...mealsWithCustom, ...meals].map((meal, idx) => {
                  if (meal.isCustom) {
                    return (
                      <Grid size={{ xs: 6, sm: 6, md: 4 }} key="custom-meal">
                        <Paper
                          className="order-meal-card"
                          onClick={() => {
                            if (products.length > 0) {
                              setOpenCustomMealPopup(true);
                            } else {
                              const waitForProducts = setInterval(() => {
                                if (products.length > 0) {
                                  setOpenCustomMealPopup(true);
                                  clearInterval(waitForProducts);
                                }
                              }, 100);
                            }
                          }}
                          sx={{
                            p: 0,
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            cursor: "pointer",
                            minWidth: {
                              xs: 170,
                              sm: 180,
                              md: 180,
                              lg: 220,
                              xl: 250,
                            },
                          }}
                        >
                          {/* Optional Image Area */}
                          <Box
                            sx={{
                              height: 160,
                              minWidth: {
                                xs: 170,
                                sm: 180,
                                md: 180,
                                lg: 220,
                                xl: 250,
                              },
                              backgroundImage: `url("/customizedMeal.png")`,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                            }}
                          />

                          {/* Text Section */}
                          <Box sx={{ p: 2, textAlign: "center", flexGrow: 1 }}>
                            <Typography
                              sx={{
                                fontSize: "clamp(1rem, 1vw, 1.5rem)",
                                fontWeight: "bold",
                                color: "#2e7d32",
                                fontFamily: "Tajawal",
                              }}
                            >
                              {t("createCustomMeal")}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "clamp(0.8rem, 0.9vw, 1.1rem)",
                                color: "#555",
                                fontFamily: "Tajawal",
                              }}
                            >
                              {t("customMealDescription") ||
                                "اختر مكوناتك بنفسك"}
                            </Typography>
                            <Typography
                              component="p"
                              sx={{
                                fontSize:
                                  "clamp(0.72rem, calc(0.28rem + 2.2vw), 0.95rem)",
                                color: "#2e7d32",
                                fontFamily: "Tajawal",
                                fontWeight: 600,
                                direction: "rtl",
                                lineHeight: 1.35,
                                m: 0,
                                mt: 0.75,
                              }}
                            >
                              {t("customMealPriceDepends")}
                            </Typography>
                          </Box>
                          <Button className="order-meal-btn" sx={{ width: "100%" }}>
                            {t("addToCart")}
                          </Button>
                        </Paper>
                      </Grid>
                    );
                  }

                  // 👇 keep your current logic for normal meals below this line
                  const existing = cart.find((item) => item.id === meal.id);
                  const count = existing ? existing.qty : 0;
                  const showAddToCart = addToCartFlags[meal.id];

                  return (
                    <Grid size={{ xs: 6, sm: 6, md: 4 }} key={meal.id || idx}>
                      <Paper
                        className="order-meal-card"
                        sx={{
                          p: 0,
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          cursor: "pointer",
                        }}
                        onClick={() => handleMealClick(meal)}
                      >
                        {/* Background image fills top */}
                        <Box
                          sx={{
                            height: 160,
                            minWidth: {
                              xs: 170,
                              sm: 180,
                              md: 180,
                              lg: 220,
                              xl: 250,
                            },
                            backgroundImage: `url(${meal.imageUrl})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                          }}
                          onClick={() => handleMealClick(meal)}
                        />

                        {/* Content below the image */}
                        <Box
                          sx={{
                            p: 0,
                            flexGrow: 1,
                            textAlign: "center",
                            px: { xs: 0.5, sm: 1 },
                            pt: 0.75,
                            pb: 0.25,
                            minHeight: { xs: "3.5rem", sm: "4rem" },
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            gap: 0.25,
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize:
                                "clamp(0.78rem, calc(0.3rem + 2.4vw), 1.2rem)",
                              fontWeight: "bold",
                              color: "#2e7d32",
                              fontFamily: "poppins",
                              lineHeight: 1.25,
                              wordBreak: "break-word",
                            }}
                            variant="subtitle1"
                          >
                            {meal.name}
                          </Typography>
                          <Typography
                            component="p"
                            sx={{
                              fontSize:
                                "clamp(0.82rem, calc(0.32rem + 2.5vw), 1.22rem)",
                              fontWeight: 700,
                              color: "#2e7d32",
                              fontFamily: "Tajawal",
                              lineHeight: 1.2,
                              m: 0,
                              letterSpacing: "0.02em",
                            }}
                          >
                            {meal.price != null && meal.price !== ""
                              ? `${meal.price} ₪`
                              : "—"}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between", // key change
                            alignItems: "center",
                            pt: 1,
                            px: 2, // optional padding
                            minHeight: "48px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 2,
                            }}
                          >
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{
                                fontSize: "clamp(0.8rem, 0.9vw, 1.3rem)",
                                direction: "rtl",
                                fontFamily: "Tajawal",
                              }}
                            >
                              {t("quantity")}
                            </Typography>
                            <TextField
                              type="number"
                              variant="standard"
                              value={count}
                              disabled={count === 0}
                              onClick={(e) => e.stopPropagation()}
                              onFocus={(e) => e.stopPropagation()}
                              onChange={(e) =>
                                handleQuantityChange(meal, e.target.value)
                              }
                              inputProps={{
                                min: 0,
                                style: {
                                  fontSize: "clamp(1rem, 1vw, 1.4rem)",
                                  textAlign: "center",
                                  width: "30px",
                                  padding: "0 4px",
                                },
                              }}
                              sx={{
                                "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                                  {
                                    "-webkit-appearance": "none",
                                    margin: 0,
                                  },
                                "& input[type=number]": {
                                  "-moz-appearance": "textfield",
                                },
                                "& .MuiInput-underline:before": {
                                  borderBottomColor: "rgba(0, 0, 0, 0.42)",
                                  borderBottom:
                                    count === 0
                                      ? 0
                                      : `1px solid rgba(0, 0, 0, 0.42)`,
                                },
                                "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                                  {
                                    borderBottomColor: "rgba(0, 0, 0, 0.87)",
                                  },
                              }}
                            />
                          </Box>

                          {showAddToCart ? (
                            <Box
                              sx={{
                                width: 40 /* IconButton size placeholder */,
                              }}
                            />
                          ) : (
                            <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                removeFromCart(meal.id);
                              }}
                              color="error"
                              sx={{
                                color: "#c62828",
                                "&:hover": {
                                  backgroundColor: "#f9d6d5",
                                },
                              }}
                            >
                              <DeleteOutlineIcon />
                            </IconButton>
                          )}
                        </Box>
                        <Box
                          sx={{
                            p: 0,
                            pt: 0,
                            textAlign: "center",
                            width: "100%",
                            justifyContent: "row",
                          }}
                        >
                          {showAddToCart && (
                            <Button
                              className="order-meal-btn"
                              sx={{ width: "100%" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                addToCart(meal);
                              }}
                            >
                              {t("addToCart")}
                            </Button>
                          )}
                          {!showAddToCart && (
                            <>
                              <Button
                                className="order-meal-btn order-meal-btn--plus"
                                sx={{ width: "50%" }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const existing = cart.find(
                                    (item) => item.id === meal.id
                                  );
                                  if (existing) {
                                    updateQty(meal.id, existing.qty + 1);
                                  } else {
                                    addToCart(meal);
                                  }
                                }}
                              >
                                +
                              </Button>
                              <Button
                                className="order-meal-btn order-meal-btn--minus"
                                sx={{ width: "50%" }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const existing = cart.find(
                                    (item) => item.id === meal.id
                                  );
                                  if (existing) {
                                    if (existing.qty === 1) {
                                      removeFromCart(existing.id);
                                    } else {
                                      updateQty(existing.id, existing.qty - 1);
                                    }
                                  }
                                }}
                              >
                                -
                              </Button>
                            </>
                          )}
                        </Box>
                      </Paper>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          </Box>
          <Box sx={{ p: 8 }}></Box>
          <ContactUs />
        </main>
      )}
      {!mealsLoading && !bundlesLoading && (
        <DiscountProgressBar total={total} />
      )}
    </div>
  );
}

export default Order;
